export default __webpack_public_path__ + "static/selectcolumnsindex-snapshot-370472c9e3d6219ab7c222951d2771be.png";